export {
  DocumentSelection,
  SelectionFeature,
} from '@aeppic/selection'

export type {
  SelectionChangedEvent,
} from '@aeppic/selection'
